import { render } from "./Cell.vue?vue&type=template&id=5d0b1d2e&scoped=true&ts=true"
import script from "./Cell.vue?vue&type=script&lang=ts"
export * from "./Cell.vue?vue&type=script&lang=ts"

import "./Cell.vue?vue&type=style&index=0&id=5d0b1d2e&scoped=true&lang=less"

import exportComponent from "/home/www-fe/fe-prod/workspace/talbook_bfe_h5_base_frame_refs-heads-master/source_code/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d0b1d2e"]])

export default __exports__